import React from 'react';
import PropTypes from 'prop-types';

import Masonry from 'react-masonry-css';

import { BREAKPOINT_COLUMNS } from './constants';
import { useStyles } from './styles';

export default function MasonryComponent({ children }) {
  const classes = useStyles();

  return (
    <Masonry
      breakpointCols={BREAKPOINT_COLUMNS}
      className={classes.grid}
      columnClassName={classes.gridColumn}
    >
      {children}
    </Masonry>
  );
}

MasonryComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
